import React, { FC } from 'react'
import s from '@widgets/Common/Footer/Footer.module.sass'
import Link from 'next/link'
import { EGG } from '@shared/api/analytics'
import IconTelegram from '@icons/social-tg.svg'
import IconVK from '@icons/social-vk.svg'
import IconDzen from '@icons/social-zn.svg'

export const FooterSocials: FC = () => (
  <div className={s.social}>
    {/* Telegram */}
    <Link
      href='https://t.me/afisharestaurants'
      onClick={() => EGG.footer.social_network_click({ social_network: 'tg' })}
      className={`${s['social-link']}`}
      target='_blank'
      scroll={false}>
      <IconTelegram />
      Telegram канал Афиша Рестораны
    </Link>

    {/* VK */}
    <Link
      href='https://vk.com/afisharestaurants'
      onClick={() => EGG.footer.social_network_click({ social_network: 'vk' })}
      className={`${s['social-link']}`}
      target='_blank'>
      <IconVK />
      ВКонтакте группа Афиша Рестораны
    </Link>

    {/* Dzen */}
    <Link
      href='https://dzen.ru/afisharests'
      onClick={() => EGG.footer.social_network_click({ social_network: 'zen' })}
      className={`${s['social-link']}`}
      target='_blank'>
      <IconDzen />
      Яндекс.Дзен блог Афиша Рестораны
    </Link>
  </div>
)
